import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { AiChatCustomValueComponent } from '../ai-chat-custom-value/ai-chat-custom-value.component';
import { AiChatGateActionsBase } from '../ai-chat-gate-actions-base';

@Component({
  selector: 'fastr-ui-ai-chat-simple-input',
  templateUrl: './ai-chat-simple-input.component.html',
  styleUrls: ['./ai-chat-simple-input.component.scss'],
})
export class AiChatSimpleInputComponent extends AiChatGateActionsBase implements OnDestroy {
  @Input() question = '';
  @Input() animateQuestion = true;
  @Input() placeholder = 'Type your answer...';
  @Input() showVoiceIcon = true;
  @Input() requireValue = true;

  @Output() submitted = new EventEmitter<string>();

  value = '';

  @ViewChild(AiChatCustomValueComponent) private customValueInput?: AiChatCustomValueComponent;

  ngOnDestroy(): void {
    this.stopVoiceDictation();
  }

  submit(): void {
    if (!this.canSubmit()) {
      return;
    }

    this.stopVoiceDictation();
    this.submitted.emit(this.value.trim());
    this.value = '';
  }

  canSubmit(): boolean {
    return !this.requireValue || this.hasAnyValue();
  }

  protected override stopVoiceDictation(): void {
    this.customValueInput?.stop();
  }

  protected override hasAnyValue(): boolean {
    return this.value.trim().length > 0;
  }
}
